import { Col, Row } from "react-bootstrap";
import { BsTelephone } from 'react-icons/bs';

 const ContatoCem = () => {
    return(
        <Row className="d-block">
            <Col>
                <label className="subheader">CANAIS DE ATENDIMENTO</label>
                <p style={{textAlign:"justify"}}>Nossos canais de comunicação estão abertos de segunda à sexta-feira, das 08:00 às 17:00.</p>
                    <i className="fa fa-phone  whatsapp mr-1"></i> +55 (15) 3035-8250
                <br/><br/><br/>
            </Col>
            <Col>
                <label className="subheader">COMERCIAL</label>
                <p style={{textAlign:"justify"}}>Se tiver dúvidas relacionadas ao valor da sua mensalidade, alterações de cadastro, ou qualquer outra informação relacionada ao seu contrato.</p>
                <a
                className="link-secondary"
                href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515991207449"
                >
                    <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99120-7449
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:comercial@esquadgroup.com.br">
                        comercial@esquadgroup.com.br
                    </a>
                </div>
                <br/><br/>
            </Col>
            <Col>
                <label className="subheader">FINANCEIRO</label>
                <p style={{textAlign:"justify"}}>Se tiver dúvidas sobre segunda via de boleto, ou informações ligadas ao financeiro.</p>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515996601996"
                >
                    <div className="pt-1">
                        <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99660-1996
                    </div>
                </a>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&phone=5515981447272"
                >
                    <div className="pt-1">
                        <i className="fab fa-whatsapp  mr-1"></i> +55 (15)98144-7272
                    </div>
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:financeiro@alumisoft.com.br">
                        financeiro@alumisoft.com.br
                    </a>
                </div>
                <br/><br/>
            </Col>
            <Col>
                <label className="subheader">RELACIONAMENTO</label>
                <p style={{textAlign:"justify"}}>Caso tenha alguma sugestão ou elogio, entre em contato com nossa equipe de Relacionamento.</p>
                <a
                className="link-secondary"
                href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515991821792"
                >
                    <div>
                        <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99182-1792
                    </div>
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:relacionamento@alumisoft.com.br">
                        relacionamento@alumisoft.com.br
                    </a>
                </div>
                <br/><br/>
            </Col>
            <Col>
                <label className="subheader">SUPORTE TÉCNICO</label>
                <p style={{textAlign:"justify"}}>Caso tenha dificuldades na utilização ou necessite de alguma assistência em nossos produtos, contate nossa equipe de suporte.</p>
                <a
                className="link-secondary"
                href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=551598176-0877"
                >
                    <div>
                        <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 98176-0877
                    </div>
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:suporte@alumisoft.com.br">
                        suporte@alumisoft.com.br
                    </a>
                </div>
            </Col>
        </Row>
    )
};

const ContatoPref = () => {
    return(
        <Row className="d-block">
            <Col>
                <label className="subheader">CANAIS DE ATENDIMENTO</label>
                <p style={{textAlign:"justify"}}> Nossos canais de comunicação estão abertos de segunda à sexta-feira, das 08:00 às 17:00.</p>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&phone=5515997250783"
                >
                    <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99725-0783
                </a>
                <div>
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:contato@prefsuite.com.br">contato@prefsuite.com.br</a>
                </div>
                <br/><br/>
            </Col>
            <Col>
                <label className="subheader">COMERCIAL</label>
                <p style={{textAlign:"justify"}}>Se tiver dúvidas relacionadas ao valor da sua mensalidade, alterações de cadastro, ou qualquer outra informação relacionada ao seu contrato.</p>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515991207449"
                >
                    <i className="fab fa-whatsapp  mr-1"></i>  +55 (15) 99120-7449
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:comercial@esquadgroup.com.br"> comercial@esquadgroup.com.br</a>
                </div>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515998599489"
                >
                    <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99859-9489
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:comercial@prefsuite.com.br">
                        comercial@prefsuite.com.br
                    </a>
                </div>
                <br/><br/>
            </Col>

            <Col>
                <label className="subheader">FINANCEIRO</label>
                <p style={{textAlign:"justify"}}> Se tiver dúvidas sobre segunda via de boleto, ou informações ligadas ao financeiro.</p>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515996804923"
                >
                    <div className="pt-1">
                        <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99680-4923
                    </div>
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:financeiro@prefsuite.com.br">
                        financeiro@prefsuite.com.br
                    </a>
                </div>
                <br/><br/>
            </Col>
            <Col>
                <div className="subheader">OUVIDORIA</div>
                <p style={{textAlign:"justify"}}>Caso tenha alguma sugestão ou elogio, entre em contato com nossa ouvidoria.</p>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:ouvidoria@alumisoft.com.br">ouvidoria@prefsuite.com.br</a>
                </div>
            </Col>
        </Row>
    )
}

const ContatoFak = () => {
    return(
        <Row className="d-block">
            <Col>
                <label className="subheader">CANAIS DE ATENDIMENTO</label>
                <p style={{textAlign:"justify"}}>Nossos canais de comunicação estão abertos de segunda à sexta-feira, das 08:00 às 17:00.</p>
                <p>
                    <BsTelephone className="mr-1"/>
                    +55 (15) 3500-8520
                </p>
                <br/>
            </Col>
            <Col>
                <label className="subheader">COMERCIAL</label>
                <p style={{textAlign:"justify"}}> Se tiver dúvidas relacionadas ao valor da sua mensalidade, alterações de cadastro, ou qualquer outra informação relacionada ao seu contrato.</p>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515991380134"
                >
                    <i className="fab fa-whatsapp  mr-1"></i>  +55 (15) 99138-0134
                </a>
                <div>
                <i className="far fa-envelope mr-1"></i>
                <a href="mailto:comercial@faktory.com.br">
                    comercial@faktory.com.br
                </a>
                </div>
                <br/><br/>
            </Col>
            <Col>
                <label className="subheader">FINANCEIRO</label>
                <p style={{textAlign:"justify"}}>Se tiver dúvidas sobre segunda via de boleto, ou informações ligadas ao financeiro.</p>
                <a
                    className="link-secondary"
                    href="https://api.whatsapp.com/send?1=pt_BR&amp;phone=5515996093219"
                >
                    <div className="pt-1">
                        <i className="fab fa-whatsapp  mr-1"></i> +55 (15) 99609-3219
                    </div>
                </a>
                <div className="pt-1">
                    <i className="far fa-envelope mr-1"></i>
                    <a href="mailto:financeiro@faktory.com.br">
                        financeiro@faktory.com.br
                    </a>
                </div>
            </Col>
        </Row>
    )
}

export {
    ContatoCem,
    ContatoPref,
    ContatoFak,
};